module.exports = __webpack_public_path__ + "img/home-title.9460584a.png";